import React, {useContext, useState} from 'react';
import * as Builder from "../../../builder";
import {ButtonBar} from "../../../builder";
import {
    RepeatedConstraint,
    RequiredConstraint
} from "../../../builder/form/validation/constraints";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {useNavigate, useParams} from "react-router-dom";
import {MyAccountPasswordEditRequest} from "../../../types/modules/user/request";
import {RepeatedType} from "../../../builder/form/type/RepeatedType";
import {PasswordType} from "../../../builder/form/type/PasswordType";
import {PasswordValidationConstraints} from "../../../builder/form/validation/form_type_constraints";
import {TextType} from "../../../builder/form/type/TextType";

export const PasswordEditForm: React.FC<{ onCancel?: () => void }> = observer(({onCancel}) => {
    const navigate = useNavigate();
    const params = useParams();
    const formReference = React.createRef() as any;

    const [fetching, setFetching] = useState<boolean>(false)
    const [formErrors, setFormErrors] = useState<any>([])

    const {
        appStore: {
            moduleStore: {
                userStore: {
                    changePassword
                }
            }
        }
    } = useContext(StoreContext);

    const onSubmit = (values: MyAccountPasswordEditRequest) => {
        setFetching(true);
        changePassword({...values, id: params.id as string})
                .then(() => {
                    navigate(`/user/${params.id}/view`);
                })
                .catch(error => {
                    setFormErrors(error.response.data.errors);
                })
                .finally(() => {
                    setFetching(false);
                })
    }

    return (
            <>
                <Builder.Form
                        translationDomain={TranslationDomainEnum.USER_ADMINISTRATION}
                        formErrors={formErrors}
                        ref={formReference}
                        items={[
                            {
                                title: <Translate message={`global.title.change_password`}/>,
                                position: 'left',
                                inputs: [
                                    {
                                        name: 'credentials.currentPassword',
                                        label: 'user.field.currentPassword',
                                        type: PasswordType,
                                        constraints: [
                                            RequiredConstraint(),
                                        ]
                                    },
                                    {
                                        name: 'credentials.otp',
                                        label: 'user.field.otp',
                                        type: TextType,
                                    },
                                    {
                                        type: RepeatedType,
                                        firstFieldName: 'plainPassword',
                                        secondFieldName: 'plainPasswordRepeat',
                                        firstLabel: 'user.field.plainPassword',
                                        secondLabel: 'user.field.plainPasswordRepeat',
                                        translationDomain: TranslationDomainEnum.USER_ADMINISTRATION,
                                        firstFieldConstraints: PasswordValidationConstraints(),
                                        secondFieldConstraints: [
                                            RequiredConstraint(),
                                            RepeatedConstraint('plainPassword'),
                                        ],
                                    },
                                ]
                            },

                        ]}
                        onFinish={(values: any) => {
                            onSubmit(values)
                        }}
                />


                <ButtonBar>
                    <Button type="primary" loading={fetching} htmlType={`submit`} onClick={() => {
                        formReference.current?.submitForm()
                    }}><Translate message={`global.button.save`}/></Button>

                    <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                        onCancel && onCancel()
                    }}><Translate message={`global.button.view`}/></Button>
                </ButtonBar>
            </>
    )
})